<template>
  <section class="manifest" id="included">
    <div class="container">
      <section-title
        align="left"
        data-aos="fade-up"
        :kicker="kicker"
        :title="title"
        :lede="lede"
      />

      <ul class="manifest-list">
        <li v-for="(item, index) in items" :key="item.title" class="manifest-item" data-aos="fade-up">
          <span class="manifest-num" aria-hidden="true">{{ String(index + 1).padStart(2, '0') }}</span>
          <div class="manifest-copy">
            <h3>{{ item.title }}</h3>
            <p>{{ item.body }}</p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

/* ---- A ruled manifest, not six more cards -------------------------------
   The closing list of both promotion landings: what the package contains,
   numbered down a light ground. Extracted from the two pages, which held
   identical rules under two different names (`.deliverable*` and
   `.unchanged*`), one of which implied the contents had changed and the
   other that they had not, for the same six-item list. */
.manifest {
  background: $ground-tint;
}

.manifest-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: 992px) {
    column-gap: 4rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.manifest-item {
  border-top: 1px solid $line-blue;
  display: grid;
  gap: 1.25rem;
  grid-template-columns: 3.4rem minmax(0, 1fr);
  padding: 1.6rem 0;
}

/* Oversized ghost numeral, standing in for the icon tile every other section
   on the site reaches for. */
.manifest-num {
  color: $tint-primary-strong;
  font-family: $headings-font-family;
  font-size: 1.7rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1;
}

.manifest-copy {
  min-width: 0;

  h3 {
    color: $text-heading;
    font-size: 1.1rem;
    line-height: 1.3;
    margin-bottom: 0.35rem;
  }

  p {
    color: $text-label;
    font-size: 0.92rem;
    line-height: 1.6;
    margin-bottom: 0;
  }
}
</style>

<script>
import SectionTitle from '@/Components/SectionTitle.vue';

export default {
  components: {
    SectionTitle
  },

  props: {
    kicker: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    lede: {
      type: String,
      default: ''
    },
    /* [{ title, body }], numbered in order from 01. */
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
